import React, { Component, Fragment } from "react";
import moment from "moment";
import NumberFormat from 'react-number-format';

export default class PrintCosting extends Component {

    state = {
        costingPrint: {}
    }

    componentWillMount() {
        const { costingPrint } = this.props
        this.setState({
            costingPrint
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.costingPrint != this.props.costingPrint) {
            this.setState({
                costingPrint: nextProps.costingPrint
            });
            //   this.calculateTotal()
        }
    }

    render() {
        // let costingPrint = this.props;
        const { costingPrint } = this.state
        console.log(costingPrint, "costingPrint")

        const { Embellishment, Embroidery, Fabric, Manufacturing, OtherCharges, SmockingShirring, Toggles, TrimObject, Wash, showLandedCalc, selectedConversion, currencyUpdate } = costingPrint

        return (
            <Fragment>
                <div className="fabricPrintDiv">
                    <style>
                        {`@media print {
                body{
                    font-family: 'Montserrat', sans-serif;
                    font-size:12px;
                }
                .fabricPrintDiv{
                    border : 2px solid black;
                    top : 0;
                    bottom : 0;
                }

                .printrow {

                    width: 100%;
                }

                .printcolumn {
                    display: flex;
                    flex-direction: column;
                    flex-basis: 100%;
                    flex: 1;
                }
                table>tbody>tr td{
                    font-size:9px;
                    text-align:center;
                }
                .label-text{
                    color:#279588;
                    font-size : 11px;
                    font-weight:bold;
                }
                .label-text2{
                    color:#279588;
                    // font-size : 11px;
                    font-weight:bold;
                }
                .blue{
                    color : #146FF9;
                }
                .padding-for-heading{
                    padding: 5px;
                }


                .specialComments{
                    width: 75%;
                    border : 1px solid black;
                    height : 60px;
                    margin: 10px;
                }

                .b{
                    border: 1px solid black;
                    margin: 10px;
                    padding: 5px;
                }
                .fabric-text{
                    font-size:16px;
                    color: #279588;
                    font-weight: 1000;
                }

                .bold{
                    font-weight:bold;
                }
                .bb-p{
                    border-bottom: 1px solid black;
                    margin-bottom: 10px ;
                }
                .w-50 {
                    width: 50%;
                }
                table.grid{
                    border-collapse: collapse;
                    margin-right: 5px;
                    margin-left: 5px;
                }
                table.grid>tbody>tr td {
                    border: 0.5px solid black;
                    text-align: center;
                    padding: 2px;
                }
                .width-for-table{
                    width: 50%;
                }
                .text-center{
                    text-align: center !important;
                }
                .p-1{
                    padding : 5px;
                }
                .pl-1{
                    padding-left: 23px;
                }
                .border-bot{
                    border-bottom : 1px solid black;
                }
                .mt{
                    margin-top:10px;
                }
                .mtl{
                    margin-top:30px;
                }
                .margin{
                    margin : 5px;
                }
                .pl-2{
                    padding: 5px;
                }
                .table-heading{
                    padding-left:5px;
                    margin:0;
                    color:#4285f4;
                    text-transform:uppercase;

                }

                .text-capitalize{
                    text-transform: capitalize;
                }

                .padding-option{
                    padding:0px 20px 0px 60px;

                }
                .paddingLeft{
                    left:100px !important;
                }
                table{
                    width:100%;
                }
                .test-class{
                    width:40%;

                    display:inline-block
                }
                .test-class1{
                    width:20%;
                    display:inline-block
                }
                .test-class2{
                    width:40%;
                    display:inline-block
                }
                .float-left{
                    float:left !important;
                }

                .padding-align-qc{
                    padding-left: 42%!important;
                }
                .text-right{
                    text-align:right !important;
                }
                .title-color{
                    padding-left:5px;
                    margin:0;
                    color:#0033cc;
                }
                .total-title-color{
                    color:#0066ff;
                }
                .float-right{
                    float:right !important;
                }
                .col-md-6{
                    width:50% !important;
                }
                .label-color{
                    color:#279588;
                    padding-left:5px;
                    margin:0;
                }
               .total-value-calc{
                   display:flex;
                   flex-direction:row-reverse;
                   padding:0 !important;
               }
               .col-md-9{
                   width:75% !important;
               }
               .col-md-3{
                   width: 25% !important;

               }
               .col-md-4{
                   width:33.3% !important;
               }
               .height-value{
                   height:160px !important;
               }
               .text-area-border{

                   border: 2px solid black !important;
               }
                }`}
                    </style>
                    <div className="bold text-center p-1 table-heading ">
                        MAGNUM CLOTHING PVT LTD - COSTING SHEET
            </div>
                    <div className="printrow bb-p">
                        <div className="text-capitalize">
                            {/* SAMPLE'S BASIC INFO TABLE START */}
                            <table>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tbody>
                                    <tr >
                                        <td className="label-text">Mag style no</td>
                                        {/* <td className="label-text">sample request no</td> */}
                                        <td className="label-text">Costing ID</td>
                                        <td className="label-text">Cust ref no</td>
                                        <td className="label-text">customer-dept</td>
                                        <td className="label-text">Mag style name</td>
                                        <td className="label-text">Costing Type</td>
                                        {/* <td className="label-text">embelishment</td>
                                        <td className="bold">{Toggles.embellishment ? "Y" : "N"}</td> */}
                                        <td className="label-text">smocking/sheering</td>
                                        <td className="bold">{Toggles.smockingSheering ? "Y" : "N"}</td>


                                    </tr>
                                    <tr>

                                        <td className="bold">{costingPrint.styleReferenceId}</td>
                                        <td className="bold">{costingPrint.key}</td>
                                        <td className="bold">{costingPrint.customerRefNumber}</td>
                                        <td className="bold">{costingPrint.customerName && costingPrint.customerName || ""}</td>
                                        <td className="bold">{costingPrint.magnumStyleName}</td>
                                        <td className="bold">{costingPrint.costingType}</td>
                                        <td className="label-text">embroidery</td>
                                        <td className="bold">{Toggles.embroidery ? "Y" : "N"}</td>
                                    </tr>
                                    <tr>
                                        <td className="label-text">costing done by</td>
                                        <td className="bold">{costingPrint.createdBy}</td>
                                        <td className="label-text">costing done on</td>
                                        <td className="bold">{costingPrint.costingCreatedTime}</td>
                                        <td className="label-text">modified by</td>
                                        <td className="bold">{costingPrint.modifiedBy ? costingPrint.modifiedBy : costingPrint.createdBy}</td>
                                        <td className="label-text">modified on</td>
                                        <td className="bold">{costingPrint.updatedAt}</td>

                                    </tr>


                                </tbody>
                            </table>
                            {/* SAMPLE'S BASIC INFO TABLE END */}


                        </div>
                    </div>




                    {/* FABRIC'S INFO TABLE START */}
                    {Fabric.FabricArrayData.length > 0 && Toggles.fabric && (

                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold">fabric cost details</p>
                                {Fabric.FabricArrayData.map((fabric, index) => {
                                    console.log(fabric, "fabric");
                                    return (
                                        <table>

                                    <tbody>
                                        <tr>
                                            <td className="label-text">fabric no</td>
                                            <td className="label-text">count & construction</td>
                                            <td className="label-text">Quality/Classification</td>
                                            <td className="label-text">supplier</td>
                                            <td className="label-text">position</td>
                                            <td className="label-text">marker</td>
                                            <td className="label-text">Print-Direction</td>
                                            <td className="label-text">size</td>
                                            <td className="label-text">width</td>
                                            <td className="label-text">consp</td>
                                            <td className="label-text">price/Mtr</td>
                                            <td className="label-text ml-auto">total/(INR)</td>
                                        </tr>
                                        <tr>

                                                    <td className="bold">{fabric.fabricNumber}</td>
                                                    <td className="bold">{fabric.countAndConstruction}</td>
                                                    <td className="bold">{fabric.qualityClassification}</td>
                                                    <td className="bold">{fabric.supplierName}</td>
                                                    <td className="bold">{fabric.fabricPosition}</td>
                                                    <td className="bold">{fabric.marker}</td>
                                                    <td className="bold">{fabric.printDirection}</td>
                                                    <td className="bold">{fabric.fabricSize}</td>
                                                    <td className="bold">{fabric.width}</td>
                                                    <td className="bold">{fabric.consumption && Number(fabric.consumption).toFixed(2) || "0.00"}</td>
                                                    <td className="bold">{fabric.price && Number(fabric.price).toFixed(2) || "0.00"}</td>
                                                    <td className="bold ml-auto"><NumberFormat value={Number(fabric.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                                <tr>
                                                    {/* Conditional Headers */}
                                                    {fabric.emb && (
                                                    <tr>
                                                        <td className="label-text">Greige</td>
                                                        <td className="label-text">Value Loss</td>
                                                        <td className="label-text">Emb</td>
                                                        <td className="label-text">Value Loss</td>
                                                        <td className="label-text">Dying/Print</td>
                                                        <td className="label-text">Up-Charge%</td>
                                                        <td className="label-text">GST</td>
                                                    </tr>
                                                    )}
                                                    {fabric.yarn && (
                                                    <tr>
                                                        <td className="label-text">Yarn Cost</td>
                                                        <td className="label-text">Up-Charge%</td>
                                                        <td className="label-text">GST</td>
                                                    </tr>
                                                    )}
                                                    {fabric.greigeset && (
                                                    <tr>
                                                        <td className="label-text">Greige</td>
                                                        <td className="label-text">Value Loss</td>
                                                        <td className="label-text">Dying/Print</td>
                                                        <td className="label-text">Up-Charge%</td>
                                                        <td className="label-text">GST</td>
                                                    </tr>
                                                    )}

          
                                                </tr>
                                                <tr>
                                                {fabric.emb && (
                                                    <tr>
                                                        <td className="bold">{fabric.greige || ''}</td>
                                                        <td className="bold">{fabric.valueLoss || ''}</td>
                                                        <td className="bold">{fabric.embCost || ''}</td>
                                                        <td className="bold">{fabric.EmbValueLoss || ''}</td>
                                                        <td className="bold">{fabric.dyingPrint || ''}</td>
                                                        <td className="bold">{fabric.upCharge || ''}{'%'}</td>
                                                        <td className="bold">{fabric.gst || fabric.defaultGst}</td>
                                                    </tr>
                                                    )}
                                                    {fabric.yarn && (
                                                    <tr>
                                                        <td className="bold">{fabric.yardDyedCost || ''}</td>
                                                        <td className="bold">{fabric.upCharge || ''}{'%'}</td>
                                                        <td className="bold">{fabric.gst || fabric.defaultGst}</td>
                                                    </tr>
                                                    )}
                                                    {fabric.greigeset && (
                                                    <tr>
                                                        <td className="bold">{fabric.greige || ''}</td>
                                                        <td className="bold">{fabric.valueLoss || ''}</td>
                                                        <td className="bold">{fabric.dyingPrint || ''}</td>
                                                        <td className="bold">{fabric.upCharge || ''}{'%'}</td>
                                                        <td className="bold">{fabric.gst || fabric.defaultGst}</td>
                                                    </tr>
                                                    )}
                                                </tr>
                                                {index===Fabric.FabricArrayData.length - 1 && (
                                                    <React.Fragment>
                                                    <tr>

                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
                                                    <td className="bold">{}</td>
        
                                                </tr>
                                                <tr>
                                                    <td colspan="11" className="label-text text-right total-title-color">Total fabric cost(INR)</td>
                                                    <td className="bold total-title-color"><NumberFormat value={Number(Fabric.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                                </React.Fragment>
                                                )}
                                                
                                                </tbody>
                                                </table>
                                    )
                                })}
                                {/* <table>

                                    <tbody>
                                        <tr>
                                            <td className="label-text">fabric no</td>
                                            <td className="label-text">count & construction</td>
                                            <td className="label-text">Quality/Classification</td>
                                            <td className="label-text">supplier</td>
                                            <td className="label-text">position</td>
                                            <td className="label-text">marker</td>
                                            <td className="label-text">Print-Direction</td>
                                            <td className="label-text">size</td>
                                            <td className="label-text">width</td>
                                            <td className="label-text">consp</td>
                                            <td className="label-text">price/Mtr</td>
                                            <td className="label-text ml-auto">total/(INR)</td>
                                        </tr>
                                        {Fabric.FabricArrayData.map((fabric, index) => {
                                            return (
                                                <tr>

                                                    <td className="bold">{fabric.fabricNumber}</td>
                                                    <td className="bold">{fabric.countAndConstruction}</td>
                                                    <td className="bold">{fabric.qualityClassification}</td>
                                                    <td className="bold">{fabric.supplierName}</td>
                                                    <td className="bold">{fabric.fabricPosition}</td>
                                                    <td className="bold">{fabric.marker}</td>
                                                    <td className="bold">{fabric.printDirection}</td>
                                                    <td className="bold">{fabric.fabricSize}</td>
                                                    <td className="bold">{fabric.width}</td>
                                                    <td className="bold">{fabric.consumption && Number(fabric.consumption).toFixed(2) || "0.00"}</td>
                                                    <td className="bold">{fabric.price && Number(fabric.price).toFixed(2) || "0.00"}</td>
                                                    <td className="bold ml-auto"><NumberFormat value={Number(fabric.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                            )
                                        })}
                                        <tr>

                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>

                                        </tr>
                                        <tr>
                                            <td colspan="11" className="label-text text-right total-title-color">Total fabric cost(INR)</td>
                                            <td className="bold total-title-color"><NumberFormat value={Number(Fabric.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                        </tr>
                                    </tbody>
                                </table> */}

                            </div>
                        </div>

                    )}
                    {/* FABRIC'S INFO TABLE END */}



                    {/* TRIM'S INFO TABLE START */}
                    {(TrimObject.trimPack.trimPackNo !== null || TrimObject.trimArrayData.length > 0) && Toggles.trim && (

                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold">trim cost details</p>

                                <table style={{ width: '100%' }}>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tbody>
                                        <tr>
                                            <td className="label-text">trim category</td>
                                            <td className="label-text">trim ref no</td>
                                            <td className="label-text">description</td>
                                            <td className="label-text">quality</td>
                                            <td className="label-text">supplier</td>
                                            <td className="label-text">size</td>
                                            <td className="label-text">consp/unit</td>
                                            <td className="label-text">price/unit</td>
                                            <td className="label-text ml-auto">total(INR)</td>

                                        </tr>
                                        {TrimObject.trimPack.trimPackNo !== null && (

                                            <tr>
                                                <td className="bold">{`Trim Pack`}</td>
                                                <td className="bold">{TrimObject.trimPack.trimPackNo}</td>
                                                <td className="bold">{TrimObject.trimPack.typeOfGmt}</td>
                                                <td className="bold">{TrimObject.trimPack.packagingMethod}</td>
                                                <td className="bold">{TrimObject.trimPack.packingType}</td>
                                                <td className="bold">{TrimObject.trimPack.subType}</td>
                                                <td className="bold">{TrimObject.trimPack.consumption && Number(TrimObject.trimPack.consumption).toFixed(2) || "0.00"}</td>
                                                <td className="bold">{TrimObject.trimPack.price && Number(TrimObject.trimPack.price).toFixed(2) || "0.00"}</td>
                                                <td className="bold ml-auto">{TrimObject.trimPack.trimPackTotalCost}</td>

                                            </tr>
                                        )}
                                        {TrimObject.trimArrayData.map((trim, index) => {
                                            return (

                                                <tr>
                                                    <td className="bold">{trim.trimCategory}</td>
                                                    <td className="bold">{trim.trimNumber}</td>
                                                    <td className="bold">{trim.description}</td>
                                                    <td className="bold">{trim.quality}</td>
                                                    <td className="bold">{trim.supplierName}</td>
                                                    <td className="bold">{trim.size}</td>
                                                    <td className="bold">{trim.consumption && Number(trim.consumption).toFixed(2) || "0.00"}</td>
                                                    <td className="bold">{trim.price && Number(trim.price).toFixed(2) || "0.00"}</td>
                                                    <td className="bold ml-auto"><NumberFormat value={Number(trim.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                            )
                                        })}
                                        <tr>
                                            <td colspan="8" className="label-text text-right total-title-color">Total trim cost(INR)</td>
                                            <td className="bold total-title-color"><NumberFormat value={Number(TrimObject.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>
                        </div>
                    )}

                    {/* TRIM'S INFO TABLE END */}

                    {/* SMOCKING SHIRRING INFO TABLE START */}
                    {SmockingShirring.smockingShirringArray.length > 0 && Toggles.smockingSheering && (

                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold">smocking shirring cost details</p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="label-text">Trim Category</td>
                                            <td className="label-text">Trim Ref Number</td>
                                            <td className="label-text">Placement</td>
                                            <td className="label-text">Type</td>
                                            <td className="label-text">No Of Rows</td>
                                            <td className="label-text">Length in Mtr</td>
                                            <td className="label-text">Total Requird Mtrs</td>
                                            <td className="label-text">price/Mtr</td>
                                            <td className="label-text ml-auto">Total/(INR)</td>
                                        </tr>
                                        {SmockingShirring.smockingShirringArray.map((smock, index) => {
                                            return (
                                                <tr>

                                                    <td className="bold">{smock.trimCategory}</td>
                                                    <td className="bold">{smock.trimNumber}</td>
                                                    <td className="bold">{smock.placement}</td>
                                                    <td className="bold">{smock.type}</td>
                                                    <td className="bold">{smock.noOfRow}</td>
                                                    <td className="bold">{smock.length}</td>
                                                    <td className="bold">{smock.totalReq && Number(smock.totalReq).toFixed(2) || "0.00"}</td>
                                                    <td className="bold">{smock.price && Number(smock.price).toFixed(2) || "0.00"}</td>
                                                    <td className="bold ml-auto`"><NumberFormat value={Number(smock.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                            )
                                        })}
                                        <tr>

                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>
                                            <td className="bold">{}</td>

                                        </tr>
                                        <tr>
                                            <td colspan="8" className="label-text text-right total-title-color">Total Smocking Shirring cost(INR)</td>
                                            <td className="bold total-title-color"><NumberFormat value={Number(SmockingShirring.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    )}
                    {/* SMOCKING SHIRRING INFO TABLE END */}

                    {/* EMBROIDERY'S INFO TABLE START */}
                    {Embroidery.EmbroideryArray.length > 0 && Toggles.embroidery && (
                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold float-left padding-option">embroidery cost details</p>
                                <p className="label-color bold float-left padding-option" >backing</p>
                                <p className="label-color bold float-left padding-option">{Embroidery.BackingArray.length ? "YES" : "NO"}</p>
                                <p className="label-color bold float-left padding-option" >bit attaching</p>
                                <p className="label-color bold">{Embroidery.bitAttaching ? "YES" : "NO"}</p>
                                <table className="w-100">
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tbody>
                                        <tr>
                                            <td className="label-text">emb placement</td>
                                            <td className="label-text">emb form</td>
                                            <td className="label-text">no of cols</td>
                                            <td className="label-text">frames</td>
                                            <td className="label-text">stiches/Mtr</td>
                                            <td className="label-text">consp</td>
                                            <td className="label-text">stitch count</td>
                                            <td className="label-text">price/1000 stitches</td>
                                            <td className="label-text ml-auto">total(INR)</td>

                                        </tr>
                                        {Embroidery.EmbroideryArray.map((data, index) => {
                                            return (
                                                <tr>
                                                    <td className="bold">{data.embPlacement}</td>
                                                    <td className="bold">{data.embForm}</td>
                                                    <td className="bold">{data.noOfCols}</td>
                                                    <td className="bold">{data.frames}</td>
                                                    <td className="bold">{data.stitchesMtr}</td>
                                                    <td className="bold">{data.consumption && Number(data.consumption).toFixed(2) || "0.00"}</td>
                                                    <td className="bold">{data.stitchCount}</td>
                                                    <td className="bold">{data.priceForStitches && Number(data.priceForStitches).toFixed(2) || "0.00"}</td>
                                                    <td className="bold ml-auto"><NumberFormat value={Number(data.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                            )
                                        })}

                                        <tr>
                                            <td colspan="8" className="label-text text-right total-title-color">Total Embroidery cost(INR)</td>
                                            <td className="bold total-title-color"><NumberFormat value={Number(Embroidery.embroideryTotalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                        </tr>
                                        {Embroidery.BackingArray.length > 0 && (
                                            <Fragment>

                                                <tr>
                                                    <td className="label-text">backing</td>
                                                    <td className="label-text">width</td>
                                                    <td className="label-text">placement</td>
                                                    <td colspan="3"></td>
                                                    <td className="label-text">consp</td>
                                                    <td className="label-text">price/mtr</td>
                                                    <td className="label-text ml-auto">total(INR)</td>
                                                </tr>

                                                {Embroidery.BackingArray.map((back, index) => {
                                                    return (
                                                        <tr>
                                                            <td className="bold">{back.backingType}</td>
                                                            <td className="bold">{back.width}</td>
                                                            <td className="bold">{back.placement}</td>
                                                            <td colspan="3"></td>
                                                            <td className="bold">{back.consumption && Number(back.consumption).toFixed(2) || "0.00"}</td>
                                                            <td className="bold">{back.price && Number(back.price).toFixed(2) || "0.00"}</td>
                                                            <td className="bold ml-auto"><NumberFormat value={Number(back.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                        </tr>
                                                    )
                                                })}

                                                <tr>
                                                    <td colspan="8" className="label-text text-right total-title-color">Total backing cost(INR)</td>
                                                    <td className="bold total-title-color"><NumberFormat value={Number(Embroidery.backingTotalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                </tr>
                                            </Fragment>
                                        )}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    )}

                    {/* EMBROIDERY'S INFO TABLE END */}

                    {/* EMBELISHMENT'S INFO TABLE START */}
                    {Embellishment.embellishmentArray.length > 0 && Toggles.embellishment && (

                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold">embellishment cost details</p>
                                <table className="no-padding-right">
                                    <tbody>
                                        <tr>
                                            <td className="col-md-6"></td>
                                            <td className="col-md-6" style={{ marginRight: "-200px" }}>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="label-text">type</td>
                                                            <td className="label-text">HH:MM</td>
                                                            <td className="label-text">price/30 mins</td>
                                                            <td className="label-text ml-auto ">total/(INR)</td>
                                                        </tr>
                                                        {Embellishment.embellishmentArray.map((data, index) => {
                                                            return (
                                                                <tr>
                                                                    <td className="bold ">{data.embType}</td>
                                                                    <td className="bold ">{moment(data.hoursMinutes).format("HH:mm")}</td>
                                                                    <td className="bold ">{data.pricePerHalfHour}</td>
                                                                    <td className="bold text-center ml-auto "><NumberFormat value={Number(data.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                                <div className="total-value-calc">
                                    <p style={{ marginRight: '30px', marginTop: "0px", marginBottom: '5px' }} className="label-text text-right total-title-color"><NumberFormat value={Number(Embellishment.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                    <p style={{ marginRight: '40px', marginTop: "0px", marginBottom: '5px' }} className="label-text text-right total-title-color">Total embelish cost(INR)</p>

                                </div>

                            </div>
                        </div>
                    )}
                    {/* EMBELISHMENT'S INFO TABLE END */}
                    {Wash.washArray.length > 0 && Toggles.wash && (

                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold float-left padding-option">wash cost details</p>
                                <p className="label-color bold float-left padding-option" >tacking</p>
                                <p className="label-color bold">Y/N</p>

                                <table className="no-padding-right">
                                    <tbody>
                                        <tr>
                                            <td className="col-md-6"></td>
                                            <td className="col-md-6 ">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="label-text">type of wash</td>
                                                            <td className="label-text">laundary unit</td>
                                                            <td className="label-text">wt/gmt</td>
                                                            <td className="label-text ">price/kg</td>
                                                            <td className=" label-text ml-auto ">total(INR)</td>
                                                        </tr>
                                                        {Wash.washArray.map((data, index) => {
                                                            return (
                                                                <tr>
                                                                    <td className="bold ">{data.washType}</td>
                                                                    <td className="bold ">{data.laundryUnit}</td>
                                                                    <td className="bold ">{data.weight}</td>
                                                                    <td className="bold ">{data.price && Number(data.price).toFixed(2) || "0.00"}</td>
                                                                    <td className="bold text-center ml-auto "><NumberFormat value={Number(data.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></td>
                                                                </tr>
                                                            )
                                                        })}


                                                    </tbody>
                                                </table>
                                            </td>

                                        </tr>




                                    </tbody>
                                </table>
                                <div className="total-value-calc">
                                    <p style={{ marginRight: '30px', marginTop: "0px", marginBottom: '5px' }} className="label-text text-right total-title-color"><NumberFormat value={Number(Wash.washCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                    <p style={{ marginRight: '40px', marginTop: "0px", marginBottom: '5px' }} className="label-text text-right total-title-color">Total wash cost(INR)</p>

                                </div>

                            </div>
                        </div>
                    )}
                    {OtherCharges.otherChargesArray.length > 0 && (

                        <div className="printrow bb-p">
                            <div className="text-capitalize">
                                <p className="title-color bold float-left padding-option">other charges</p>
                                <div className="total-value-calc">
                                    <p style={{ marginRight: '10px', marginBottom: '0', marginTop: "0px" }} className="label-text">total(INR)</p>

                                </div>
                                {OtherCharges.otherChargesArray.map((data, index) => {
                                    return (
                                        <div className="total-value-calc">
                                            <p style={{ marginRight: '30px', marginBottom: '0', marginTop: "0px", fontSize: '10px' }} className="bold">{data.value && Number(data.value).toFixed(2) || data.value}</p>
                                            <p style={{ marginRight: '40px', marginBottom: '0', marginTop: "0px", fontSize: '10px' }} className=" bold">{data.label}</p>
                                        </div>
                                    )
                                })}

                                <div className="total-value-calc">
                                    <p style={{ marginRight: '30px', marginBottom: '0', marginTop: "5px" }} className="label-text text-right total-title-color"><NumberFormat value={Number(OtherCharges.otherTotalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                    <p style={{ marginRight: '40px', marginBottom: '0', marginTop: "5px" }} className="bold total-title-color">Total other cost(INR)</p>

                                </div>
                            </div>
                        </div>
                    )}

                    <div className="printrow bb-p">
                        <div className="text-capitalize">
                            <p className="title-color bold">manufacturing process / piece cost details</p>

                            <table className="w-100">

                                <tbody>

                                    <tr>
                                        <td className="col-md-6 ">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className="label-text">order qty</td>
                                                        <td className="label-text">SAM@80%</td>
                                                        {/* <td className="label-text">SAM@80%</td> */}
                                                        <td className="label-text">rev / tailor @{costingPrint.Manufacturing.perMachine}</td>
                                                        <td className="label-text">rev / machine @1750</td>

                                                    </tr>
                                                    <tr>
                                                        <td className="bold ">{Manufacturing.orderQty}</td>
                                                        <td className="bold ">{Manufacturing.smv100}</td>
                                                        {/* <td className="bold ">{Manufacturing.smv80}</td> */}
                                                        <td className="bold ">{Manufacturing.revTailer}</td>
                                                        <td className="bold ">{Manufacturing.revMachine}</td>

                                                    </tr>

                                                </tbody>
                                            </table>
                                        </td>
                                        <td className="col-md-6">
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold"><NumberFormat value={Number(Manufacturing.fixedCharge).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                                <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="label-text bold">Fixed charges</p>

                                            </div>
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">{Manufacturing.CMT}</p>
                                                <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">CMT @ {Manufacturing.CMTSelected}</p>

                                            </div>
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold"><NumberFormat value={Number(Manufacturing.totalCost).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                                <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="bold">total manufacturing cost</p>

                                            </div>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td className="col-md-3">
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className="label-text">sample</td>
                                                        <td className="label-text">dated</td>
                                                        <td className="label-text">pattern</td>
                                                        <td className="label-text">dated</td>

                                                    </tr>
                                                    <tr>
                                                        <td className="bold ">{Manufacturing.selectedMenu.name === 'sample' ? Manufacturing.selectedMenu.value : "N/A"}</td>
                                                        <td className="bold ">{Manufacturing.selectedMenu.name === 'sample' ? moment(Manufacturing.selectedMenu.data).format('Do MMM YYYY') : 'N/A'}</td>
                                                        <td className="bold ">{Manufacturing.selectedMenu.name === 'pattern' ? Manufacturing.selectedMenu.value : "N/A"}</td>
                                                        <td className="bold ">{Manufacturing.selectedMenu.name === 'pattern' ? moment(Manufacturing.selectedMenu.data).format('Do MMM YYYY') : "N/A"}</td>

                                                    </tr>

                                                </tbody>
                                            </table>
                                        </td>
                                        <td className="col-md-9">
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px' }} className="bold"><NumberFormat value={Number(Manufacturing.others.valueLoss.total).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                                <p style={{ marginRight: '5px', marginBottom: '0px' }} className="label-text2 bold">{Number(Manufacturing.others.valueLoss.value).toFixed(2)}%</p>
                                                <p style={{ marginRight: '5px', marginBottom: '0px' }} className="bold">value loss</p>
                                            </div>
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold"><NumberFormat value={Number(Manufacturing.others.overHeads.total).toFixed(2)} displayType={'text'} thousandSeparator={true} /></p>
                                                <p style={{ marginRight: '5px', marginBottom: '0px', marginTop: "0px" }} className="label-text2 bold">{Number(Manufacturing.others.overHeads.value).toFixed(2)}%</p>
                                                <p style={{ marginRight: '10px', marginBottom: '0px', marginTop: "0px" }} className="bold">contribution to overheads</p>
                                            </div>
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold"><NumberFormat value={Manufacturing.costingTotal} displayType={'text'} thousandSeparator={true} /></p>
                                                <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">total cost(INR)</p>
                                            </div>
                                            <div className="total-value-calc">
                                                <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold">
                                                    {selectedConversion === "usd" && <span className="bold">${Manufacturing.currencies.usd.total}</span>}
                                                    {selectedConversion === "gbp" && <span className="bold">£{Manufacturing.currencies.gbp.total}</span>}
                                                    {selectedConversion === "euro" && <span className="bold">€{Manufacturing.currencies.eur.total}</span>}
                                                </p>
                                                <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="bold">
                                                        {selectedConversion === "usd" && `USD-$-${currencyUpdate && currencyUpdate.usd !== undefined && currencyUpdate.usd !== null ? currencyUpdate.usd : Manufacturing.currencies.usd.value}`}
                                                        {selectedConversion === "gbp" && `GBP-£-${currencyUpdate && currencyUpdate.gbp !== undefined && currencyUpdate.gbp !== null ? currencyUpdate.gbp : Manufacturing.currencies.gbp.value}`}
                                                        {selectedConversion === "euro" && `Euro-€-${currencyUpdate && currencyUpdate.eur !== undefined && currencyUpdate.eur !== null ? currencyUpdate.eur : Manufacturing.currencies.eur.value}`}
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>


                        </div>
                    </div>
                    {
                        !showLandedCalc && <div className="printrow ">
                            <div className="text-capitalize height-value" >
                                {/* <p className="bold" style={{ marginBottom: "0px", paddingLeft: "5px" }}>If landed,then the working is : </p> */}
                                <div className="col-md-4 float-left" >
                                    <table>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-4 float-left">
                                    <table>
                                        <tbody>
                                            {/* <td className="col-md-4">
                                                <tr>
                                                    {selectedConversion === "usd" && <td className="bold">USD-$-{Manufacturing.currencies.usd.value}</td>}
                                                    {selectedConversion === "gbp" && <td className="bold">GBP-£-{Manufacturing.currencies.gbp.value}</td>}
                                                    {selectedConversion === "euro" && <td className="bold">Euro-€-{Manufacturing.currencies.eur.value}</td>}
                                                </tr>
                                                <tr>
                                                    {selectedConversion === "usd" && <td className="bold">${Manufacturing.currencies.usd.total}</td>}
                                                    {selectedConversion === "gbp" && <td className="bold">£{Manufacturing.currencies.gbp.total}</td>}
                                                    {selectedConversion === "euro" && <td className="bold">€{Manufacturing.currencies.eur.total}</td>}
                                                </tr>
                                            </td> */}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-4 float-left">
                                    <table>
                                        <tbody>
                                            <td className="col-md-4">
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold">{Manufacturing.shipment.shipmentTerm}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="bold">shipment term</p>

                                                </div>
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold">{Manufacturing.shipment.shipmentMode}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="bold">ship mode</p>

                                                </div>
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">{Manufacturing.agreedCurrency || '$'}{Manufacturing.agreedPrice}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">agreed price</p>
                                                </div>
                                            </td>
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>

                    }
                    {showLandedCalc == true ? (
                        <div className="printrow ">
                            <div className="text-capitalize height-value" >
                                <p className="bold" style={{ marginBottom: "0px", paddingLeft: "5px" }}>If landed,then the working is : </p>
                                <div className="col-md-4 float-left" >

                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="label-text">conversion to</td>
                                                <td className="bold ">{Manufacturing.fromCurrencyConvertion} to {Manufacturing.toCurrencyConvertion}</td>
                                                <td className="bold"><NumberFormat value={Manufacturing.conversionTotal} displayType={'text'} thousandSeparator={true} /></td>
                                            </tr>
                                            <tr>
                                                <td className="label-text">conversion rate</td>
                                                <td className="bold">{Manufacturing.coversionRate}</td>
                                                <td className="bold">{Manufacturing.rateValue}</td>
                                            </tr>
                                            <tr>
                                                <td className="label-text">Freight charges</td>
                                                <td className="bold"><NumberFormat value={Manufacturing.freightCharges} displayType={'text'} thousandSeparator={true} prefix={Manufacturing.toCurrencyConvertion === 'GBP' ? '£' : Manufacturing.toCurrencyConvertion === 'EUR' ? '€' : '$'} /></td>
                                                <td className="bold"><NumberFormat value={Manufacturing.freightTotal} displayType={'text'} thousandSeparator={true} prefix={Manufacturing.toCurrencyConvertion === 'GBP' ? '£' : Manufacturing.toCurrencyConvertion === 'EUR' ? '€' : '$'} /></td>
                                            </tr>
                                            <tr>
                                                <td className="label-text">duty</td>
                                                <td className="bold"><NumberFormat value={Manufacturing.dutyValue} displayType={'text'} thousandSeparator={true} prefix={'%'} /></td>
                                                <td className="bold"><NumberFormat value={Manufacturing.dutyTotal} displayType={'text'} thousandSeparator={true} prefix={Manufacturing.toCurrencyConvertion === 'GBP' ? '£' : Manufacturing.toCurrencyConvertion === 'EUR' ? '€' : '$'} /></td>
                                            </tr>
                                            <tr>
                                                <td className="label-text">processing cost</td>
                                                <td className="bold"><NumberFormat value={Manufacturing.processingCost} displayType={'text'} thousandSeparator={true} prefix={Manufacturing.toCurrencyConvertion === 'GBP' ? '£' : Manufacturing.toCurrencyConvertion === 'EUR' ? '€' : '$'} /></td>
                                                <td className="bold"><NumberFormat value={Manufacturing.processValue} displayType={'text'} thousandSeparator={true} prefix={Manufacturing.toCurrencyConvertion === 'GBP' ? '£' : Manufacturing.toCurrencyConvertion === 'EUR' ? '€' : '$'} /></td>
                                            </tr>
                                            <tr>
                                                <td className="label-text"></td>
                                                <td className="total-title-color bold">Total landed cost</td>
                                                <td className="total-title-color bold"><NumberFormat value={Manufacturing.totalLanding} displayType={'text'} thousandSeparator={true} prefix={Manufacturing.toCurrencyConvertion === 'GBP' ? '£' : Manufacturing.toCurrencyConvertion === 'EUR' ? '€' : '$'} /></td>
                                            </tr>

                                        </tbody>
                                    </table>

                                </div>
                                {/* <div className="col-md-4 float-left">
                                    <table>
                                        <tbody>
                                            <td className="col-md-4">
                                                <tr>
                                                    <td className="bold">USD-$-{Manufacturing.currencies.usd.value}</td>
                                                    <td className="bold">GBP-£-{Manufacturing.currencies.gbp.value}</td>
                                                    <td className="bold">Euro-€-{Manufacturing.currencies.eur.value}</td>
                                                </tr>
                                                <tr>
                                                    <td className="bold">${Manufacturing.currencies.usd.total}</td>
                                                    <td className="bold">£{Manufacturing.currencies.gbp.total}</td>
                                                    <td className="bold">€{Manufacturing.currencies.eur.total}</td>
                                                </tr>
                                            </td>
                                        </tbody>
                                    </table>
                                </div> */}
                                <div className="col-md-4 float-left">
                                    <table>
                                        <tbody>
                                            <td className="col-md-4">
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold">{Manufacturing.shipment.shipmentTerm}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="bold">shipment term</p>

                                                </div>
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="bold">{Manufacturing.shipment.shipmentMode}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="bold">ship mode</p>

                                                </div>
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">{Manufacturing.landedPrice}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">landed price</p>

                                                </div>
                                                <div className="total-value-calc">
                                                    <p style={{ marginRight: '30px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">{Manufacturing.agreedCurrency || '$'}{Manufacturing.agreedPrice}</p>
                                                    <p style={{ marginRight: '40px', marginBottom: '0px', marginTop: "0px" }} className="total-title-color bold">agreed price</p>
                                                </div>
                                            </td>
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>
                    ) : null}

                    <div style={{ paddingLeft: "17%" }} className="comments-height">
                        <p className="bold" style={{ marginBottom: '0' }} >Special Comments :</p>
                        <div style={{ width: "85%", border: '1px solid black', padding: '5px' }}>
                            {Manufacturing.comments && Manufacturing.comments.split('\n').map(comment => {
                                return <p style={{ wordWrap: 'break-word', margin: "0" }}>{comment}</p>
                            })}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Costing/printCosting.js